import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const PRODUCTCATEGORYBLOCK_LEGACY_FIELD_ORDER = [
  "category"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  productCategoryBlockDescriptor: _generatedProductCategoryBlockDescriptor,
  productCategoryBlockBlocDefinition,
  productCategoryBlockDashboardLayout,
  productCategoryBlockConfig,
  productCategoryBlockResolveConfig,
  productCategoryBlockProperties,
} = doodBlockConfig(
  {
    name: "Product category",
    componentType: 'ProductCategoryBlockComponent',
    category: 'catalog',
    description: "Product category.",
    keywords: [],
    sharedFields: {}
  },

  () => ({
    category: propertyValue({
      type: 'product_category_picker',
      value: '',
      options: {
        label: "pages.blocks.product-category.category.label",
      },
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.product-category.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.product-category.fieldset.category.label",
            fields: ["category"],
          },
        ],
      },
    ],
  })
);

export function productCategoryBlockDescriptor(): IBlockDescriptor;
export function productCategoryBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function productCategoryBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedProductCategoryBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedProductCategoryBlockDescriptor, productCategoryBlockProperties, fieldOrder);
}

export {
  productCategoryBlockBlocDefinition,
  productCategoryBlockDashboardLayout,
  productCategoryBlockProperties,
  productCategoryBlockConfig,
  productCategoryBlockResolveConfig,
};

export type ProductCategoryBlockConfig = typeof productCategoryBlockConfig;
